import { __awaiter } from "tslib";
import Vue from 'vue';
import { ActivePopupTypes } from '@/store/modules/popup/types';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { YubikeyAuthMixin } from '@/mixins/YubikeyAuthMixin';
import { StepByStepGlossary } from '@/constants/services';
import { findMinimumWithdrawalAmount } from '@/components/pages/spotPage/trade/helpers/index';
import { declOfNum } from '@/utils/numbers';
import stepByStepValidate from '@/services/_helpers/stepByStepValidate';
const updateAmountValue = _.debounce(function (context, newValue) {
    context.form.fields.amount.value = newValue;
}, 400);
let availableNetworks = {};
const networksRules = {};
function tryFindNetwork(address) {
    const matchesArray = Object.entries(networksRules).reduce((arr, curr) => {
        const [key, value] = curr;
        if (value(address))
            arr.push(key);
        return arr;
    }, []);
    if (matchesArray.length) {
        return matchesArray.length === 1
            ? 'TRX'
            : 'BSC';
    }
    else
        return false;
}
const getNetworkShortName = (name) => availableNetworks[name];
const userLimits = {
    availableBalance: '',
    limits: {},
    limitUsed: ''
};
function getListTemplate(item) {
    var _a;
    const filters = this.$options.filters;
    let result = '';
    result += `<span class="fz-14">${filters.fixString(item.name, 25)}</span>`;
    if (item.network) {
        result += `<span class="d-block" style="color: #D1D1D1">${item.network}</span>`;
    }
    if (item.blurredAddress) {
        result += `<span class="d-block" style="color: #D1D1D1; white-space: normal; letter-spacing: 0.4px">${(_a = item.address) !== null && _a !== void 0 ? _a : item.blurredAddress}</span>`;
    }
    return result;
}
export default Vue.extend({
    name: 'transfersOutbound',
    mixins: [YubikeyAuthMixin],
    data: function () {
        return {
            depositAddress: null,
            selectedAssetName: '',
            selectedNetwork: 0,
            withdraw: {},
            selectedWhitelistAddress: '',
            selectedWhitelistID: '',
            whitelistAddresses: [],
            deposit: {},
            withdrawalMinAmounts: {},
            networkUnavailable: false,
            networkUnavailableText: '',
            kycError: false,
            havePermissionToTransfer: false,
            form: {
                valid: false,
                fields: {
                    amount: {
                        value: '',
                        touched: false,
                        rules: []
                    }
                }
            },
            loadError: false,
            isRetry: false,
            withdrawsPossibility: {
                isBlocked: false,
                blockData: null
            }
        };
    },
    computed: Object.assign(Object.assign({}, mapGetters('user', ['getUserData'])), { transferAmountDisabled() {
            return (!this.selectedAsset && this.selectedWhitelistID === '') || this.limitIsLessMinTransferAmount || this.currentCoinQuantityIsNotEnough || this.withdrawsPossibility.isBlocked || this.currentCoinQuantityIsNotEnoughForCurrentNetwork || !this.transferAvailable;
        },
        transferAvailable() {
            return !this.kycError && this.havePermissionToTransfer;
        }, formatCurrencyType() {
            return this.selectedAssetName === 'USDT' || this.selectedAssetName === 'BUSD' ? 'USDT' : 'BNB';
        },
        userNetworksMap() {
            return _.uniq(this.whitelistAddresses.map((item) => getNetworkShortName(item.network || '') || ''));
        },
        availableNetworks() {
            var _a;
            const asset = (_a = this.withdraw[this.selectedAssetName]) !== null && _a !== void 0 ? _a : {};
            const networks = Object.keys(asset);
            if (networks.length > 0) {
                return networks;
            }
            return ['TRX', 'ETH', 'BSC'];
        },
        assetAutocompleteItems() {
            const vm = this;
            return Object.keys(this.withdraw)
                .filter((asset) => parseFloat(this.deposit[asset]) >= this.withdrawalMinAmounts[asset])
                .map((asset) => ({
                label: asset,
                value: asset
            }));
        },
        selectedAsset() {
            var _a;
            if (!this.withdraw[this.selectedAssetName])
                return null;
            if (!this.availableNetworks[this.selectedNetwork])
                return null;
            const item = ((_a = this.withdraw[this.selectedAssetName]) !== null && _a !== void 0 ? _a : {})[this.availableNetworks[this.selectedNetwork]];
            if (!item)
                return null;
            const isCommisionOk = item.commission && item.commission.length;
            const isMinimumAmountOk = item.minimumAmount && item.minimumAmount.length;
            const isDepositOk = this.deposit[this.selectedAssetName] && this.deposit[this.selectedAssetName].length;
            if (!isCommisionOk || !isMinimumAmountOk || !isDepositOk)
                return null;
            return {
                asset: this.selectedAssetName,
                commission: item.commission,
                minimumAmount: item.minimumAmount,
                availableAmount: this.deposit[this.selectedAssetName],
                assetNetworks: this.selectedAssetName.length ? Object.keys(this.withdraw[this.selectedAssetName.toUpperCase()]) : [],
                realMinimumAmount: this.$options.filters.formatToCurrency(this.NS(item.minimumAmount).minus(this.NS(item.commission)), this.formatCurrencyType, true)
            };
        },
        currentCoinQuantityIsNotEnoughForCurrentNetwork() {
            if (!this.selectedAsset)
                return false;
            if (!(this.selectedAsset.asset in userLimits.limits))
                return false;
            if (typeof this.selectedWhitelistID === 'string')
                return false;
            const selectedWallet = this.whitelistAddresses.find((item) => item.id === this.selectedWhitelistID);
            // @ts-ignore
            if (!selectedWallet)
                return false;
            // @ts-ignore
            if (!selectedWallet.network)
                return false;
            const walletNetwork = getNetworkShortName(selectedWallet.network);
            const networkRules = this.withdraw[this.selectedAsset.asset][walletNetwork];
            const realMinAmount = this.NS(networkRules.minimumAmount).minus(this.NS(networkRules.commission));
            const result = this.NS(this.deposit[this.selectedAssetName]).lte(this.NS(realMinAmount));
            if (result && this.$route.query.isRebuild && this.selectedAsset && this.transferSum) {
                this.$store.dispatch('alertsBus/openAlert', {
                    title: 'Ошибка',
                    type: 'error',
                    autoDelete: true,
                    content: `Не удалось выполнить перевод на сумму ${this.NS(this.transferSum).toString()} ${this.selectedAsset.asset}, так как остатка монеты недостаточно для перевода в выбранной сети`
                });
            }
            return result;
        },
        selectedAssetRules() {
            const vm = this;
            const getAmountOfCurrentCoin = () => {
                return vm.$options.filters.formatMoney(vm.$options.filters.formatToCurrency(vm.deposit[vm.selectedAsset.asset], vm.formatCurrencyType)) +
                    ' ' +
                    vm.selectedAsset.asset;
            };
            return [
                (v) => v.length > 0 || '',
                (v) => {
                    const foundAutocompleteItem = this.assetAutocompleteItems.find((item) => item.label.toLowerCase() === v.toLowerCase());
                    if (foundAutocompleteItem !== undefined)
                        return true;
                    return Object.keys(this.withdraw).indexOf(v) === -1 ? 'Перевод этой монеты недоступен' : 'Остатка этой монеты недостаточно для перевода';
                },
                () => {
                    return !vm.currentCoinQuantityIsNotEnough || 'Остатка этой монеты недостаточно для перевода';
                },
                () => {
                    return vm.currentCoinQuantityIsNotEnoughForCurrentNetwork
                        ? `Остатка этой монеты (${getAmountOfCurrentCoin()}) недостаточно для перевода в кошельке выбранной сети`
                        : '';
                }
            ];
        },
        transferSum() {
            return this.NS(this.form.fields.amount.value).plus(this.NS(this.selectedAsset.commission)).toNumber();
        },
        computedWalletsList() {
            const vm = this;
            const filters = this.$options.filters;
            if (!this.selectedAssetName || this.currentCoinQuantityIsNotEnough) {
                return [{
                        key: -1,
                        value: 'Выберите монету',
                        isActive: false
                    }];
            }
            let networkAvailable = false;
            const result = this.whitelistAddresses
                .filter((item) => {
                if (!item.isValidAddress && item.isValidAddress !== null)
                    return;
                if (!item.network)
                    return true;
                return vm.availableNetworks.includes(getNetworkShortName(item.network));
            })
                .map((item) => {
                const fullNetworkName = item.network;
                const shortNetworkKey = getNetworkShortName(fullNetworkName);
                networkAvailable = shortNetworkKey ? this.depositAddress[this.selectedAssetName][shortNetworkKey].available : true;
                return ({
                    key: item.id,
                    address: filters.fixString(item.name, 25),
                    value: getListTemplate.call(vm, item),
                    showAppendIcon: !networkAvailable
                });
            });
            if (result.length)
                return result;
            return [{
                    key: -1,
                    value: 'Нет подходящих кошельков',
                    isActive: false
                }];
        },
        computedWhitelistName() {
            var _a;
            return ((_a = this.selectedWhitelistAddress) === null || _a === void 0 ? void 0 : _a.length) ? this.selectedWhitelistAddress : 'Выбрать кошелёк';
        },
        currentWalletIsIncorrect() {
            const walletID = this.selectedWhitelistID;
            if (typeof walletID === 'string')
                return false;
            const fullWalletData = this.whitelistAddresses.find((item) => item.id === walletID);
            if (!fullWalletData)
                return false;
            return Boolean(!fullWalletData.network || !fullWalletData.isValidAddress);
        },
        selectedWalletData() {
            if (!this.selectedWhitelistID)
                return null;
            const vm = this;
            const findedItem = this.whitelistAddresses.find((item) => item.id === vm.selectedWhitelistID);
            return findedItem || null;
        },
        getTextOfDisabledTransferButton() {
            if (!this.transferAvailable)
                return 'Пройдите верификацию';
            if (!this.selectedAsset)
                return 'Выберите монету';
            if (!this.selectedAssetName)
                return 'Выберите монету';
            if (this.currentCoinQuantityIsNotEnough)
                return 'Остатка этой монеты недостаточно для перевода';
            if (!this.selectedWhitelistID)
                return 'Выберите кошелек';
            if (this.currentCoinQuantityIsNotEnoughForCurrentNetwork)
                return 'Остатка этой монеты недостаточно </br>для перевода в кошельке выбранной сети';
            if (this.limitIsLessMinTransferAmount)
                return 'Пройдите продвинутую верификацию </br>для увеличения лимита на выводы';
            if (!this.form.fields.amount.value)
                return 'Введите сумму';
            return '';
        },
        getRealMaximumAmount() {
            if (!this.selectedAsset)
                return '';
            if (!(this.selectedAsset.asset in userLimits.limits))
                return '';
            let commission = this.NS('0');
            if (this.selectedWhitelistID) {
                commission = this.NS(this.selectedAsset.commission);
            }
            else {
                commission = this.NS(Object.values(this.withdraw[this.selectedAsset.asset]).reduce((acc, curr) => {
                    if (curr.commission > acc)
                        acc = curr.commission;
                    return acc;
                }, 0));
            }
            if (this.NS(userLimits.limits[this.selectedAsset.asset]).gt(this.NS(this.deposit[this.selectedAsset.asset]))) {
                return this.NS(this.deposit[this.selectedAsset.asset]).minus(commission).toString();
            }
            else
                return this.NS(userLimits.limits[this.selectedAsset.asset]).minus(commission).toString();
        },
        amountIsInvalid() {
            if (!this.selectedAsset)
                return false;
            if (this.NS(this.form.fields.amount.value).lt(this.NS(this.selectedAsset.realMinimumAmount)))
                return true;
            if (this.NS(this.form.fields.amount.value).gt(this.NS(this.getRealMaximumAmount)))
                return true;
            return false;
        },
        limitIsLessMinTransferAmount() {
            if (!this.selectedAsset)
                return false;
            if (!(this.selectedAsset.asset in userLimits.limits))
                return false;
            return this.NS(userLimits.limits[this.selectedAsset.asset]).lte(this.NS(this.selectedAsset.realMinimumAmount));
        },
        currentCoinQuantityIsNotEnough() {
            if (!this.selectedAsset)
                return false;
            if (!(this.selectedAsset.asset in userLimits.limits))
                return false;
            const vm = this;
            const realMinAmount = Object.entries(this.withdraw[this.selectedAsset.asset]).reduce((acc, curr) => {
                const [key, value] = curr;
                if (!vm.userNetworksMap.includes(key))
                    return acc;
                const currentMinimalValue = vm.NS(value.minimumAmount).minus(vm.NS(value.commission));
                if (currentMinimalValue.lt(vm.NS(acc)))
                    acc = currentMinimalValue;
                return acc;
            }, Infinity);
            const result = this.NS(this.deposit[this.selectedAssetName]).lte(this.NS(realMinAmount).isFinite() ? this.NS(realMinAmount) : 0);
            return result;
        } }),
    filters: {
        walletAddressFilter(wallet) {
            if (wallet.address)
                return wallet.address;
            if (wallet.blurredAddress)
                return wallet.blurredAddress;
            return '******************************************';
        },
        filterBlockTimeToText(blockTime) {
            if (!blockTime)
                return '24 часа';
            const hoursTextDininition = blockTime.h ? blockTime.h + ' ' + declOfNum(blockTime.h, ['час', 'часа', 'часов']) : '';
            const minutesTextDefinition = blockTime.m ? blockTime.m + ' ' + declOfNum(blockTime.m, ['минуту', 'минуты', 'минут']) : '1 минуту';
            return `Действует временное ограничение на выводы и создание API-ключей на ${hoursTextDininition} ${minutesTextDefinition} в связи со сменой настроек безопасности.`;
        }
    },
    watch: {
        'form.fields.amount.value'(newValue) {
            if (newValue.includes(',')) {
                setTimeout(() => {
                    this.form.fields.amount.value = newValue.split(',').join('.');
                }, 50);
            }
            if (newValue.indexOf('.') !== -1) {
                const decimalLength = this.$options.filters.formatToCurrency(newValue, this.formatCurrencyType).split('.')[1].length;
                const formattedValue = newValue.substring(0, newValue.indexOf('.') + decimalLength + 1);
                updateAmountValue(this, formattedValue);
            }
        },
        selectedAssetName() {
            this.form.fields.amount.value = '';
            this.form.fields.amount.touched = false;
            this.selectedWhitelistAddress = 'Выбрать кошелёк';
            this.selectedWhitelistID = '';
            this.form.fields.amount.value = '';
        },
        whitelistAddresses(newArr) {
            const vm = this;
            if (newArr.length && this.selectedAssetName) {
                vm.selectedWhitelistAddress = newArr[0].value;
                vm.selectedWhitelistID = newArr[0].key;
            }
        },
        selectedWhitelistID(newValue) {
            if (newValue) {
                const wallet = this.computedWalletsList.find((wallet) => wallet.key === newValue);
                this.networkUnavailable = wallet.showAppendIcon;
                if (this.networkUnavailable) {
                    const adressNetworkName = this.whitelistAddresses.find((address) => address.id === newValue).network;
                    this.networkUnavailableText = this.$t('transfersPage.outbound.alerts.selectedWalletNetwork', { network: adressNetworkName });
                }
            }
            let result = 0;
            const walletID = newValue;
            if (typeof walletID === 'string')
                result = 0;
            const fullWalletData = this.whitelistAddresses.find((item) => item.id === walletID);
            if (!fullWalletData || !fullWalletData.network || !fullWalletData.isValidAddress) {
                result = 0;
            }
            else {
                result = this.availableNetworks.indexOf(getNetworkShortName(fullWalletData.network));
            }
            this.selectedNetwork = result < 0 ? 0 : result;
        },
        assetAutocompleteItems(newValue, oldValue) {
            if (Object.keys(oldValue).length)
                return;
            if (this.$route.query.withdraw && Object.values(newValue).find((item) => item.value === this.$route.query.withdraw)) {
                this.selectedAssetName = this.$route.query.withdraw;
                return;
            }
            if (Object.values(newValue).find((item) => item.value === 'USDT')) {
                this.selectedAssetName = 'USDT';
            }
        }
    },
    methods: {
        handleAmountInputBlur() {
            const newValue = this.form.fields.amount.value;
            if (this.NS(newValue).isNaN() || this.NS(newValue).isZero()) {
                this.form.fields.amount.value = '';
                this.form.fields.amount.touched = false;
            }
        },
        showLimitPopup() {
            const vm = this;
            const filters = this.$options.filters;
            const userVerificationLevel = vm.getUserData.verificationRights.levelName;
            const formatCurrency = (currency) => filters.removeTrailingZeros(filters.formatMoney(filters.formatToCurrency(this.NS(currency), 'usdt')), ',');
            this.$store.dispatch('popupModule/openPopup', {
                type: ActivePopupTypes.action,
                letDefaultClose: true,
                title: this.$t('transfersPage.popups.amountRange.header'),
                content: '',
                slot: {
                    name: 'amountRangePopupChunk',
                    data: {
                        type: 'walletSelected',
                        limitData: {
                            daysLimit: this.getUserData.verificationRights.currentLevelMonthLimit ? formatCurrency(this.getUserData.verificationRights.currentLevelMonthLimit) + ' USDT' : this.$t('transfersPage.popups.amountRange.notLimited'),
                            transfered: formatCurrency(userLimits.limitUsed),
                            limit: this.NS(userLimits.availableBalance).isFinite() ? formatCurrency(userLimits.availableBalance) + ' USDT' : this.$t('transfersPage.popups.amountRange.notLimited'),
                            limitNS: this.NS(userLimits.availableBalance)
                        },
                        // @ts-ignore
                        verificationLevel: userVerificationLevel
                    }
                },
                actions: [
                    {
                        title: 'Хорошо',
                        isAccent: true,
                        callback: () => { vm.$store.commit('popupModule/setClosed'); }
                    }
                ]
            });
        },
        openAmountRangePopup() {
            const vm = this;
            let popupByWalletTypes;
            (function (popupByWalletTypes) {
                popupByWalletTypes["oldWallet"] = "oldWallet";
                popupByWalletTypes["walletNotSelected"] = "walletNotSelected";
                popupByWalletTypes["walletSelected"] = "walletSelected";
            })(popupByWalletTypes || (popupByWalletTypes = {}));
            const filters = this.$options.filters;
            const formatCurrency = (currency) => filters.removeTrailingZeros(filters.formatMoney(filters.formatToCurrency(this.NS(currency), 'usdt')), ',');
            const userVerificationLevel = vm.getUserData.verificationRights.levelName;
            const getWalletType = () => {
                return !this.selectedWalletData
                    ? popupByWalletTypes.walletNotSelected
                    : this.selectedWalletData.network
                        ? popupByWalletTypes.walletSelected
                        : popupByWalletTypes.oldWallet;
            };
            const isUnlimitedTransfers = !this.NS(userLimits.availableBalance).isFinite();
            const dailyLimit = _.get(this.getUserData.permissions.binance, 'transfers.withdraw.limit');
            this.$store.dispatch('popupModule/openPopup', {
                type: ActivePopupTypes.action,
                letDefaultClose: true,
                title: this.$t('transfersPage.popups.amountRange.header'),
                content: '',
                slot: {
                    name: 'amountRangePopupChunk',
                    data: {
                        type: getWalletType(),
                        limitData: {
                            daysLimit: isUnlimitedTransfers ? this.$t('transfersPage.popups.amountRange.notLimited') : formatCurrency(dailyLimit) + ' USDT',
                            transfered: formatCurrency(userLimits.limitUsed),
                            limit: isUnlimitedTransfers ? this.$t('transfersPage.popups.amountRange.notLimited') : formatCurrency(userLimits.availableBalance) + ' USDT',
                            limitNS: this.NS(userLimits.availableBalance)
                        },
                        // @ts-ignore
                        verificationLevel: userVerificationLevel
                    }
                },
                actions: [
                    {
                        title: 'Хорошо',
                        isAccent: true,
                        callback: () => { vm.$store.commit('popupModule/setClosed'); }
                    }
                ]
            });
        },
        setSsid(savedWalletSecret) {
            return __awaiter(this, void 0, void 0, function* () {
                const sessionResponse = yield this.services.mainService.confirmSession({ sessionId: StepByStepGlossary.doTransfer });
                if (sessionResponse.success) {
                    const response = yield stepByStepValidate({
                        name: StepByStepGlossary.doTransfer,
                        endpointName: StepByStepGlossary.validateSession,
                        data: {
                            sessionId: sessionResponse.data.session_id,
                            payload: { wallet_secret: savedWalletSecret }
                        },
                        steps: 3
                    });
                    if (response.success) {
                        localStorage.setItem('withdrawSSID', JSON.stringify(sessionResponse.data));
                    }
                }
            });
        },
        toggleWalletAddressVisibility(wallet) {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                const checkCurrentWalletIsInvalid = (walletSecret) => {
                    const currentWallet = vm.whitelistAddresses.findIndex((item) => item.id === wallet.id);
                    const deleteCurrentWalletFromList = () => {
                        vm.whitelistAddresses.splice(currentWallet, 1);
                        vm.selectedWhitelistAddress = '';
                        vm.selectedWhitelistID = 0;
                    };
                    if (currentWallet >= 0 && !tryFindNetwork(vm.whitelistAddresses[currentWallet].address)) {
                        this.$store.dispatch('popupModule/openPopup', {
                            type: ActivePopupTypes.action,
                            letDefaultClose: true,
                            title: 'Некорректный адрес кошелька',
                            content: 'Адрес этого кошелька не соответствует ни одной из доступных сетей (BNB Smart Chain (BEP20), Tron (TRC20), Ethereum (ETH20)). Перевод на этот кошелёк невозможен. </br></br>Удалить кошелёк?',
                            actions: [
                                {
                                    title: 'Удалить',
                                    isAccent: true,
                                    callback: () => __awaiter(this, void 0, void 0, function* () {
                                        const response = yield vm.services.mainService.deleteWhitelistWallet({
                                            walletSecret,
                                            ids: [vm.whitelistAddresses[currentWallet].id]
                                        });
                                        if (response.success) {
                                            vm.$store.commit('popupModule/setClosed');
                                            vm.$store.dispatch('alertsBus/openAlert', {
                                                title: 'Успешно',
                                                type: 'success',
                                                autoDelete: true,
                                                content: 'Кошелёк удалён'
                                            });
                                            deleteCurrentWalletFromList();
                                        }
                                        else {
                                            vm.$store.dispatch('alertsBus/openAlert', {
                                                title: 'Ошибка',
                                                type: 'error',
                                                autoDelete: true,
                                                content: 'Не удалось удалить кошелек'
                                            });
                                        }
                                    })
                                },
                                {
                                    title: 'Позже',
                                    isAccent: false,
                                    callback() {
                                        vm.$store.commit('popupModule/setClosed');
                                        deleteCurrentWalletFromList();
                                    }
                                }
                            ]
                        });
                    }
                };
                if (wallet.address) {
                    localStorage.removeItem('withdrawSSID');
                    for (let i = 0; i < this.whitelistAddresses.length; i++) {
                        this.whitelistAddresses[i].address = null;
                    }
                }
                else {
                    this.$store.dispatch('popupModule/openPopup', {
                        type: ActivePopupTypes.action,
                        letDefaultClose: true,
                        title: 'Просмотр адресов',
                        content: '',
                        slot: {
                            name: 'confirmSecretCodeToShowAddressesPopupChunk',
                            data: {
                                name: vm.$route.query.name,
                                isLoading: false
                            },
                            on: {
                                onConfirm(walletSecret) {
                                    return __awaiter(this, void 0, void 0, function* () {
                                        vm.$store.commit('popupModule/setClosed');
                                        const response = yield vm.services.mainService.getWhitelistWalletsWithAddresses({
                                            walletSecret
                                        });
                                        if (response.success) {
                                            for (const index in response.data.wallets) {
                                                const item = response.data.wallets[index];
                                                const itemIndexInInstance = vm.whitelistAddresses.findIndex((wallet) => wallet.id === item.id);
                                                if (itemIndexInInstance >= 0)
                                                    Vue.set(vm.whitelistAddresses[itemIndexInInstance], 'address', item.address);
                                            }
                                            vm.setSsid(walletSecret);
                                            checkCurrentWalletIsInvalid(walletSecret);
                                        }
                                        else {
                                            vm.$store.dispatch('alertsBus/openAlert', {
                                                title: 'Ошибка',
                                                type: 'error',
                                                autoDelete: true,
                                                content: 'Не удалось расшифровать адреса кошельков'
                                            });
                                        }
                                    });
                                }
                            }
                        },
                        actions: []
                    });
                }
            });
        },
        doTransfer() {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                if (this.currentWalletIsIncorrect) {
                    localStorage.setItem('transferPreset', JSON.stringify({
                        amount: this.transferSum,
                        whitelist: this.selectedWhitelistID,
                        coin: this.selectedAsset.asset
                    }));
                    this.$router.push({
                        name: 'whitelistsResolveNetworksPage',
                        query: {
                            id: this.selectedWhitelistID,
                            name: this.selectedWhitelistAddress,
                            isFromTransfersPage: true
                        }
                    });
                    return;
                }
                const outboundTransferResponseHandler = (response) => {
                    vm.$store.commit('popupModule/setClosed');
                    if (response.success) {
                        vm.$store.dispatch('alertsBus/openAlert', {
                            title: '',
                            type: 'info',
                            autoDelete: true,
                            onlyContent: true,
                            content: `Перевод на сумму ${vm.NS(vm.transferSum).toString()} ${vm.selectedAsset.asset} на кошелёк «${vm.selectedWalletData.name}» принят.`
                        });
                        vm.$emit('onOutTransferCompleted');
                        return;
                    }
                    const errors = response.data.errors;
                    if (errors) {
                        errors.forEach((error) => {
                            vm.$store.dispatch('alertsBus/openAlert', {
                                title: this.$t('alerts.errorTitle'),
                                type: 'error',
                                autoDelete: true,
                                content: error
                            });
                        });
                        return;
                    }
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: this.$t('alerts.errorTitle'),
                        type: 'error',
                        autoDelete: true,
                        content: this.$t('transfersPage.outbound.alerts.transferError')
                    });
                };
                let codes, sessionId;
                // @ts-ignore
                const ssid = localStorage.getItem('withdrawSSID') ? JSON.parse(localStorage.getItem('withdrawSSID')) : false;
                if (ssid) {
                    codes = ssid.confirmations;
                    sessionId = ssid.session_id;
                }
                else {
                    const sessionResponse = yield vm.services.mainService.confirmSession({ sessionId: StepByStepGlossary.doTransfer });
                    codes = sessionResponse.data.confirmations;
                    sessionId = sessionResponse.data.session_id;
                }
                const summaryWithdrawData = {
                    asset: this.selectedAsset.asset,
                    accrualAmount: this.NS(this.form.fields.amount.value).toString(),
                    writeOffAmount: this.NS(this.transferSum).toString(),
                    commission: this.NS(this.selectedAsset.commission).toString(),
                    walletData: this.selectedWalletData
                };
                if (this.getUserData.confirmation === 'yubikey') {
                    vm.$store.dispatch('popupModule/openPopup', {
                        type: ActivePopupTypes.action,
                        letDefaultClose: true,
                        title: 'Перевод со спотового кошелька монеты ' + this.selectedAsset.asset,
                        content: 'Для подтверждения перевода введите секретный код от белого списка адресов.',
                        slot: {
                            name: 'widthdrawConfirmWalletSecretYubikeyPopupChunk',
                            data: {
                                steps: 3,
                                secretConfirmed: Boolean(ssid),
                                name: StepByStepGlossary.doTransfer,
                                endpointName: StepByStepGlossary.validateSession,
                                sessionId,
                                summaryWithdrawData,
                                codes
                            },
                            on: {
                                onSubmit() {
                                    const yubiKeyDoTransfer = () => __awaiter(this, void 0, void 0, function* () {
                                        vm.YubikeyAuth(StepByStepGlossary.doTransfer, null, (authResponse) => __awaiter(this, void 0, void 0, function* () {
                                            var _a;
                                            if (!authResponse.success) {
                                                vm.$store.commit('popupModule/setClosed');
                                                vm.$store.dispatch('alertsBus/openAlert', {
                                                    title: this.$t('alerts.errorTitle'),
                                                    type: 'error',
                                                    autoDelete: true,
                                                    content: (_a = authResponse.errors.join('\n')) !== null && _a !== void 0 ? _a : this.$t('transfersPage.outbound.alerts.transferYubiKeyError')
                                                });
                                                return;
                                            }
                                            const response = yield vm.services.mainService.doOutboundTransfer({
                                                sessionId,
                                                payload: {
                                                    amount: vm.transferSum,
                                                    whitelist: +vm.selectedWhitelistID,
                                                    coin: vm.selectedAsset.asset
                                                }
                                            });
                                            outboundTransferResponseHandler(response);
                                        }), sessionId, yubiKeyDoTransfer);
                                    });
                                    yubiKeyDoTransfer();
                                }
                            }
                        },
                        actions: []
                    });
                    return;
                }
                vm.$store.dispatch('popupModule/openPopup', {
                    type: ActivePopupTypes.action,
                    letDefaultClose: true,
                    title: 'Перевод со спотового кошелька монеты ' + this.selectedAsset.asset,
                    content: '',
                    slot: {
                        name: 'walletSecret2FAPopupChunk',
                        data: {
                            steps: 3,
                            secretConfirmed: Boolean(ssid),
                            name: StepByStepGlossary.doTransfer,
                            endpointName: StepByStepGlossary.validateSession,
                            sessionId,
                            summaryWithdrawData,
                            codes
                        },
                        on: {
                            onSuccess() {
                                return __awaiter(this, void 0, void 0, function* () {
                                    const response = yield vm.services.mainService.doOutboundTransfer({
                                        sessionId,
                                        payload: {
                                            amount: vm.transferSum,
                                            whitelist: +vm.selectedWhitelistID,
                                            coin: vm.selectedAsset.asset
                                        }
                                    });
                                    outboundTransferResponseHandler(response);
                                });
                            }
                        }
                    },
                    actions: []
                });
            });
        },
        handleClickSetAll() {
            this.form.fields.amount.touched = true;
            const depositWithoutComission = this.NS(this.getRealMaximumAmount);
            const currencyFormatDeposit = this.$options.filters.formatToCurrency(depositWithoutComission, this.formatCurrencyType);
            this.form.fields.amount.value = currencyFormatDeposit;
        },
        init() {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                this.loadError = false;
                this.isRetry = true;
                const response = yield this.services.mainService.getTransfersPaymentData(null);
                this.kycError = response.status === 403;
                if (this.kycError) {
                    this.isRetry = false;
                    return;
                }
                const whitelistsResponse = yield this.services.mainService.getWhitelistWallets(null);
                if (response.success && whitelistsResponse.success) {
                    if (response.data.availableAfter) {
                        this.withdrawsPossibility.isBlocked = true;
                        this.withdrawsPossibility.blockData = response.data.availableAfter;
                    }
                    userLimits.availableBalance = response.data.availableBalance;
                    userLimits.limits = response.data.limits;
                    userLimits.limitUsed = response.data.limitUsed;
                    this.deposit = response.data.deposit;
                    this.withdraw = response.data.withdraw;
                    const withdrawableAssets = Object.keys(response.data.withdraw);
                    withdrawableAssets.forEach(key => {
                        this.withdrawalMinAmounts[key] = findMinimumWithdrawalAmount(response.data.withdraw[key]);
                    });
                    this.whitelistAddresses = whitelistsResponse.data.wallets;
                    availableNetworks = whitelistsResponse.data.networks.reduce((arr, curr) => {
                        arr[curr.label] = curr.key;
                        return arr;
                    }, {});
                    this.depositAddress = response.data.depositAddress;
                    whitelistsResponse.data.networks.forEach((item) => {
                        networksRules[item.key] = (v) => {
                            const reg = new RegExp(item.rule);
                            return reg.test(v);
                        };
                    });
                    const transferPreset = JSON.parse(String(localStorage.getItem('transferPreset')));
                    const findedWallet = transferPreset && this.whitelistAddresses.find((item) => item.id === transferPreset.whitelist);
                    if (findedWallet && this.$route.query.isRebuild) {
                        Vue.set(this, 'selectedAssetName', transferPreset.coin);
                        setTimeout(() => {
                            Vue.set(this, 'selectedWhitelistID', transferPreset.whitelist);
                            Vue.set(this, 'selectedWhitelistAddress', findedWallet.name);
                            this.$nextTick(() => {
                                Vue.set(vm.form.fields.amount, 'touched', true);
                                Vue.set(vm.form.fields.amount, 'value', vm.NS(transferPreset.amount).minus(vm.NS(vm.selectedAsset.commission)).toString());
                            });
                        }, 100);
                    }
                    localStorage.removeItem('transferPreset');
                }
                else {
                    this.loadError = true;
                }
                this.isRetry = false;
            });
        }
    },
    created() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.init();
            this.havePermissionToTransfer = this.getUserData.permissions.binance.transfers.withdraw.available;
        });
    }
});
